import {
  Stack,
  Menu,
  Divider,
  MenuItem,
} from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import baseURL from "../../../configs/api";
import { QuotesDetailsPopup } from "../../carrental/quotes/QuotesDetailsPopup";
import { useTheme } from "../../../components/hooks/useTheme";
import { useNavigate } from "react-router-dom";
import axois from "../../../configs/axois";
import { bookingsStatusColorCode } from "../../../utils/statusColorCode";
import { CustomDataGrid } from "../../../components/common/CustomDataGrid";
import colorConfigs from "../../../configs/colorConfigs";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";
import moment from "moment";
import useGeneral from "../../../components/hooks/useGeneral";

const filterItems = [
  {
    id: 0,
    label: "Vehicle Class",
  },
  {
    id: 1,
    label: "Branch Name",
  },
]

type Props = {
  idNumber: string;
};

export default function CustomerQuotes({ idNumber }: Props) {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { themeStyles } = useTheme();
  const { handleTenantError }: any = useTenant();
  const navigate = useNavigate();
  const { dateFormat }: any = useGeneral();
  const [quotesFilterValue, setQuotesFilterValue] = useState(0);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [particularQuotes, setParticularQuotes] = useState<any>();
  const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);
  const [fullName, setFullName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [searchValue, setSearchValue] = useState<string>("");
  const [totalLength, setTotalLength] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [searchTableData, setSearchTableData] = useState<any[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [columnFilterAnchorEl, setColumnFilterAnchorEl] = useState<null | HTMLElement>(null);
  const columnFilterOpen = Boolean(columnFilterAnchorEl);
  const initialColumns: GridColDef[] = [
    {
      field: "id",
      headerName: "#",
      width: 300,
      editable: false,
      sortable: false,
      align: "left",
    },
    {
      field: "reservationType",
      headerName: "Reservation Type",
      width: 170,
      align: "left",
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <span onClick={() => {
            setShowPopup(true);
            setParticularQuotes(params.row);
          }}
            style={{ color: "var(--app-link-color)" }}
            className="underline cursor-pointer">
            {params?.value}
          </span>
        );
      },
    },
    {
      field: "customerEmail",
      headerName: "Customer Email",
      width: 170,
      align: "left",
      editable: false,
      sortable: false,
    },
    {
      field: "pickupDate",
      headerName: "Pickup Date",
      width: 170,
      align: "left",
      editable: false,
      sortable: false,
    },
    {
      field: "returenDate",
      headerName: "Return Date",
      width: 170,
      align: "left",
      editable: false,
      sortable: false,
    },
    {
      field: "vehicleClassName",
      headerName: "Vehicle Class",
      align: "left",
      width: 300,
      editable: false,
      sortable: false,
    },
    {
      field: "branchName",
      headerName: "Branch Name",
      align: "left",
      width: 200,
      editable: false,
      sortable: false,
    },
    {
      field: "commissionPartner",
      headerName: "Commission Patner",
      align: "left",
      width: 300,
      editable: false,
      sortable: false,
    },
    {
      field: "clientPay",
      headerName: "Client pays at Commission Patner",
      align: "left",
      width: 150,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        let color = {
          colorBg: "#000000",
          colorText: "#000000"
        };
        color = params.value === "Yes" ? {
          colorBg: "bg-[#D9F4D4]",
          colorText: "text-[#039855]"
        }
          :
          {
            colorBg: "bg-[#FEDFDD]",
            colorText: "text-[#D92D20]"
          }
        return (
          <div className="flex items-end h-full">
            <span className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${color.colorBg} ${color.colorText}`}>
              {params.value}
            </span>
          </div>
        )
      }
    },
    {
      field: "rackPrice",
      headerName: "Rack Price",
      align: "left",
      width: 120,
      editable: false,
      sortable: false,
    },
    {
      field: "totalPrice",
      headerName: "Total Price",
      align: "left",
      width: 120,
      editable: false,
      sortable: false,
    },
    {
      field: "status",
      headerName: "Status",
      align: "left",
      width: 120,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        let color = {
          colorBg: "#000000",
          colorText: "#000000"
        };
        color = bookingsStatusColorCode?.find((color: any) => color?.label === params?.value?.trim()?.toLowerCase()) || {
          colorBg: "#000000",
          colorText: "#000000"
        };

        return (
          <div className="flex items-end h-full">
            <span className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${color.colorBg} ${color.colorText}`}>
              {params.value}
            </span>
          </div>
        );
      }
    },
    {
      field: "discount",
      headerName: "Discount",
      align: "left",
      width: 120,
      editable: false,
      sortable: false,
    },
    {
      field: "tag",
      headerName: "Tags",
      align: "left",
      width: 120,
      editable: false,
      sortable: false,
    },
  ];
  const [columns, setColumns] = useState<GridColDef[]>(initialColumns);
  const [selectedColumns, setSelectedColumns] = useState(initialColumns?.map(col => col?.headerName));

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleColumnFilterClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setColumnFilterAnchorEl(event.currentTarget);
  };
  const handleColumnFilterClose = () => {
    setColumnFilterAnchorEl(null);
  };

  const toggleColumn = (headerName: string) => {
    setSelectedColumns(prev =>
      prev.includes(headerName) ? prev.filter(col => col !== headerName) : [...prev, headerName]
    );
  };

  useEffect(() => {
    const filterCol = initialColumns?.filter(col => selectedColumns?.includes(col?.headerName));
    setColumns(filterCol);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedColumns])

  useEffect(() => {
    axois
      .get(`${baseURL}Customer/${idNumber}`, {
        headers: {
          'X-Tenant-ID': tenantId,
          "Content-Type": "application/json"
        },
      })
      .then((response) => {
        setFullName(response.data.firstName + " " + response.data.lastName);
        setEmail(response.data.emailAddress);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idNumber])

  const toggleAll = () => {
    if (selectedColumns?.length === initialColumns?.length) {
      setSelectedColumns([]);
    } else {
      setSelectedColumns(initialColumns?.map(col => col?.headerName));
    }
  };

  useEffect(() => {
    if (searchValue === "" && !isFirstTime) {
      const newPaginationModel = {
        page: 0,
        pageSize: paginationModel.pageSize,
      };

      setPaginationModel(newPaginationModel);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  useEffect(() => {
    if (searchValue === "") {
      setIsFirstTime(false);
      emptySearchApiCall(paginationModel);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationModel])

  const emptySearchApiCall = (newPaginationModel: any) => {
    setLoading(true);
    fetch(`${baseURL}quote/GetQuotesPagingForCustomer/${idNumber},${newPaginationModel.page},${newPaginationModel.pageSize}`, {
      method: "GET",
      headers: {
        'X-Tenant-ID': tenantId,
        "Content-Type": "application/json"
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const result = data.quoteReports.map((item: any) => {
          return {
            ...item,
            pickupDate: item.pickupDate
              ? moment(new Date(item.pickupDate)).format(dateFormat + "hh:mm a")
              : "",
            returenDate: item.returenDate
              ? moment(new Date(item.returenDate)).format(dateFormat + "hh:mm a")
              : "",
            customerEmail: email,
            clientPay: item.clientPaysatCommissionPartner ? "Yes" : "No",
            totalPrice: "$" + item.totalPrice?.toFixed(2),
            rackPrice: "$" + item.rackPrice?.toFixed(2),
            securityDepositAmount: "$" + item.securityDepositAmount?.toFixed(2),
            discount: "$" + item.discount?.toFixed(2),
          };
        });

        setSearchTableData(result);
        setTotalLength(data.count);
        setLoading(false);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
        setSearchTableData([]);
        setLoading(false);
      });
  }

  useEffect(() => {
    let timeOutId: NodeJS.Timeout;

    if (searchValue !== "") {
      timeOutId = setTimeout(() => {
        const newPaginationModel = {
          page: 0,
          pageSize: paginationModel?.pageSize,
        };

        setPaginationModel(newPaginationModel);
      }, 1000);
    }

    return () => clearTimeout(timeOutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  useEffect(() => {
    if (searchValue !== "") {
      apiCall(paginationModel);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationModel])

  const apiCall = (newPaginationModel: any) => {
    let filterData: any[] = [];
    setLoading(true);
    switch (quotesFilterValue) {
      case 0:
        fetch(`${baseURL}quote/GetQuotesSearchWithVehicleClassNameForCustomer?vehicleClassName=${searchValue}&customerId=${idNumber}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
          method: "GET",
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
          },
        })
          .then((res) => res.json())
          .then((data) => {
            filterData = data.quoteReports.map((item: any) => {
              return {
                ...item,
                pickupDate: item.pickupDate
                  ? moment(new Date(item.pickupDate)).format(dateFormat + "hh:mm a")
                  : "",
                returenDate: item.returenDate
                  ? moment(new Date(item.returenDate)).format(dateFormat + "hh:mm a")
                  : "",
                customerEmail: email,
                clientPay: item.clientPaysatCommissionPartner ? "Yes" : "No",
                totalPrice: "$" + item.totalPrice?.toFixed(2),
                rackPrice: "$" + item.rackPrice?.toFixed(2),
                securityDepositAmount: "$" + item.securityDepositAmount?.toFixed(2),
                discount: "$" + item.discount?.toFixed(2),
              };
            });

            setSearchTableData(filterData);
            setTotalLength(data.count);
            setLoading(false);
            handleTenantError(null);
          })
          .catch((error) => {
            handleTenantError(error);
            setSearchTableData([]);
            setTotalLength(0);
            setLoading(false);
          });
        break;
      case 1:
        fetch(`${baseURL}quote/GetQuotesSearchWithBranchNameForCustomer?branchName=${searchValue}&customerId=${idNumber}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
          method: "GET",
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
          },
        })
          .then((res) => res.json())
          .then((data) => {
            filterData = data.quoteReports.map((item: any) => {
              return {
                ...item,
                pickupDate: item.pickupDate
                  ? moment(new Date(item.pickupDate)).format(dateFormat + "hh:mm a")
                  : "",
                returenDate: item.returenDate
                  ? moment(new Date(item.returenDate)).format(dateFormat + "hh:mm a")
                  : "",
                customerEmail: email,
                clientPay: item.clientPaysatCommissionPartner ? "Yes" : "No",
                totalPrice: "$" + item.totalPrice?.toFixed(2),
                rackPrice: "$" + item.rackPrice?.toFixed(2),
                securityDepositAmount: "$" + item.securityDepositAmount?.toFixed(2),
                discount: "$" + item.discount?.toFixed(2),
              };
            });

            setSearchTableData(filterData);
            setTotalLength(data.count);
            setLoading(false);
            handleTenantError(null);
          })
          .catch((error) => {
            handleTenantError(error);
            setSearchTableData([]);
            setTotalLength(0);
            setLoading(false);
          });
        break;
    }
  }


  return (
    <>
      <div className="w-full mt-2">
        <div className={`w-full pb-4`}>
          <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
            <div className="flex items-center gap-1.5">
              <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Customer - {fullName}</h2>
            </div>

            <div className="flex items-center gap-1.5">

              <button className={`px-[12px] py-[10px] ${colorConfigs.btn.main.tailwind} shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                onClick={() => {
                  navigate(`/carrental/reservations/addreservation?customerId=${idNumber}`);
                }}
              >
                <span className="text-xs font-medium">New Reservation</span>
              </button>
            </div>
          </div>
        </div>
        <div className={`w-full border ${themeStyles.main.borderColor} rounded-[16px]`}>
          <div className={`flex justify-between items-center p-4 border-b ${themeStyles.main.borderColor}`}>
            <div className="flex items-center gap-1.5">

              <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Quotes</h2>

              <div >
                <button
                  className={`flex items-center justify-between py-[5px] px-[12px] gap-2.5 rounded-lg border border-solid ${themeStyles.topBar.tailwindBorderColor}`}
                  aria-controls={columnFilterOpen ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={columnFilterOpen ? 'true' : undefined}
                  onClick={handleColumnFilterClick}
                >
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <span className={`${themeStyles.topBar.tailwindTextColor} text-[14px] font-medium`}>Columns</span>
                    <span className={`material-symbols-outlined text-[18px] font-light ${themeStyles.main.textHeadingColor}`}>
                      filter_alt
                    </span>
                  </Stack>
                </button>

                <Menu
                  id="basic-menu"
                  anchorEl={columnFilterAnchorEl}
                  open={columnFilterOpen}
                  onClose={handleColumnFilterClose}
                  slotProps={{
                    paper: {
                      sx: {
                        width: 170,
                        maxHeight: 300,
                        backgroundColor: themeStyles.topBar.bg
                      }
                    }
                  }}
                >
                  <div className="flex items-center gap-2 px-[16px] py-[6px] w-full">
                    <input
                      type="checkbox"
                      className="form-checkbox cursor-pointer"
                      checked={selectedColumns?.length === initialColumns?.length ? true : false}
                      onClick={toggleAll}
                    />
                    <span className={`${themeStyles.topBar.tailwindTextColor} font-medium text-[12px]`}>Select All</span>
                  </div>
                  <Divider className="w-full" />
                  {
                    initialColumns?.map((column, index) => (
                      <>
                        <MenuItem
                          key={index}
                          sx={{
                            fontSize: "12px",
                            marginBlock: "0px",
                            "&: hover": {
                              cursor: "default"
                            }
                          }}
                        >
                          <div className="flex items-center gap-2">
                            <input
                              type="checkbox"
                              className="form-checkbox cursor-pointer"
                              checked={selectedColumns.includes(column?.headerName)}
                              onChange={() => toggleColumn(column?.headerName || "")}
                            />
                            <span className={`${themeStyles.topBar.tailwindTextColor} font-medium`}>{column?.headerName}</span>
                          </div>

                        </MenuItem>
                        <Divider className="w-full" />
                      </>
                    ))
                  }
                </Menu>
              </div>
            </div>
            <div className="flex items-center gap-1.5">
              <div >
                <button
                  className={`flex items-center justify-between py-[5px] px-[12px] gap-2.5 rounded-lg border border-solid ${themeStyles.topBar.tailwindBorderColor}`}
                  aria-controls={open ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClick}
                >
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <span className={`${themeStyles.topBar.tailwindTextColor} text-[14px] font-medium`}>{selectedFilter}</span>
                    {open ? <span className={`material-symbols-outlined ${themeStyles.topBar.tailwindTextColor} text-[25px] font-extralight`}>
                      keyboard_arrow_up
                    </span> : <span className={`material-symbols-outlined ${themeStyles.topBar.tailwindTextColor} text-[25px] font-extralight`}>
                      keyboard_arrow_down
                    </span>}
                  </Stack>
                </button>

                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  slotProps={{
                    paper: {
                      sx: {
                        width: 170,
                        backgroundColor: themeStyles.topBar.bg
                      }
                    }
                  }}
                >
                  {
                    filterItems?.map((filter, index) => (
                      <>
                        <MenuItem
                          key={index}
                          sx={{ fontSize: "12px", marginBlock: "0px" }}
                          onClick={() => {
                            setSelectedFilter(filter.label)
                            setQuotesFilterValue(filter.id)
                            setAnchorEl(null);

                          }}>
                          <span className={`${themeStyles.topBar.tailwindTextColor} text-[16px] font-medium`}>{filter.label}</span>
                        </MenuItem>
                        <Divider className="w-full" />
                      </>
                    ))

                  }
                </Menu>
              </div>
              <div className={`flex px-[5px] py-[6px] items-center gap-2.5 rounded-lg border ${themeStyles.main.borderColor} shadow-sm`}>
                <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                  search
                </span>
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchValue}
                  className={`border-none outline-none w-full ${themeStyles.main.textSubHeadingColor} bg-transparent`}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </div>
            </div>
          </div>

          <CustomDataGrid
            filteredRows={searchTableData}
            totalLength={totalLength}
            columns={columns?.map(col => ({
              ...col,
              headerClassName: themeStyles.table.headerBg,
            }))}
            loading={loading}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
          />
        </div>
      </div>

      <QuotesDetailsPopup
        particularQuotes={particularQuotes}
        showPopup={showPopup}
        hidePopup={() => setShowPopup(false)}
        deleteQuote={(_: number) => {
          setSearchValue("");
          setShowPopup(false);
        }}
      />
    </>
  );
}